<div class="metric-snapshots-wrapper">
  <gh-indicator [ghValue]="indicators.loadingUpdate" [ghMessage]="'loading_update' | localize"></gh-indicator>
  <gh-indicator [ghValue]="indicators.refreshingMetric" [ghMessage]="'updating' | localize"></gh-indicator>
  <gh-indicator [ghValue]="indicators.doNotDisplaySnapshots" [ghMessage]="'loading' | localize"></gh-indicator>

  <ng-container *ngIf="!indicators.doNotDisplaySnapshots">
    <div class="metric-snapshots" *ngFor="let snapshotItem of history | slice : 0 : limitSnapshotsTo; trackBy: trackById">
      <metric-snapshot-previews [snapshot]="snapshotItem" [metric]="metric" [sourceMetric]="sourceMetric"></metric-snapshot-previews>

      <div class="reactions-with-show-comments">
        <reactions [(reactions)]="reactions[snapshotItem.id]" [target]="snapshotItem" targetType="checkin"></reactions>
        <show-comments-button [commentsCount]="snapshotItem.commentsCount" (showCommentsButtonClick)="showComments(snapshotItem)" onPageUsed="metric"></show-comments-button>
      </div>
    </div>
  </ng-container>

  <button
    *ngIf="limitSnapshotsTo < metric.metricHistory.length && !indicators.doNotDisplaySnapshots"
    (click)="limitSnapshotsTo = limitSnapshotsTo + limitSnapshotsStep"
    ui-button
    uiSize="default"
    uiShape="round"
    uiType="default">
    {{ "load_more" | localize }}
  </button>
</div>
